import React from "react";
import { FaUpload, FaBoxOpen, FaDollarSign } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { Container, Item } from "./topMenu.styled";
import { StyledSelect } from "../common/common.style";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEmail,
  selectGame,
  setAddToken,
  setEmail,
  setGame,
  setJwtToken,
} from "../../store/slices/global";
import { Box, FlexBox, Option } from "../primitives";
import { FiList, FiLogOut } from "react-icons/fi";
import { useGetGamesQuery } from "../../services/myServer/games";
import { GiDoctorFace } from "react-icons/gi";

export const TopMenu = () => {
  const game = useSelector(selectGame);
  const email = useSelector(selectEmail);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: games } = useGetGamesQuery();
  const menuItems = [
    {
      label: "Upload Cards",
      icon: <FaUpload size={14} />,
      path: "/upload-cards",
    },
    {
      label: "My Inventory",
      icon: <FaBoxOpen size={14} />,
      path: "/inventory",
    },
    { label: "Pricing", icon: <FaDollarSign size={14} />, path: "/pricing" },
    { label: "Transaction", icon: <FiList size={14} />, path: "/transaction" },
    {
      label: "Sanity",
      icon: <GiDoctorFace size={14} />,
      path: "/sanity-check",
    },
  ];

  return (
    <Container as="nav">
      <FlexBox css={{ gap: 10, color: "white", "@mdRev": { order: 1 } }}>
        <Box
          css={{ cursor: "pointer" }}
          onClick={() => {
            localStorage.removeItem("authToken");
            dispatch(setEmail(""));
            dispatch(setAddToken(""));
            dispatch(setJwtToken(""));
            navigate("/");
          }}
        >
          <FiLogOut size={16} color="white" />
        </Box>
        {email}
      </FlexBox>
      <FlexBox css={{ gap: 20, "@mdRev": { margin: "auto" } }}>
        {menuItems.map((item) => (
          <Link
            key={item.label}
            to={item.path}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item>
              {item.icon}
              <span>{item.label}</span>
            </Item>
          </Link>
        ))}
      </FlexBox>
      <Box css={{ "@mdRev": { order: 2 } }}>
        <StyledSelect
          css={{ width: 100 }}
          value={game?.id}
          onChange={(e) => {
            const foundGame = games?.games?.find(
              (aGame) => aGame?.id === +e.target.value
            );
            if (foundGame) dispatch(setGame(foundGame));
          }}
        >
          {games?.games?.map((aGame) => (
            <Option value={aGame.id} key={aGame.id}>
              {aGame.display_name}
            </Option>
          ))}
        </StyledSelect>
      </Box>
    </Container>
  );
};
